'use client';

import { ActionIcon, Tooltip } from '@mantine/core';
import { IconHeart, IconHeartFilled } from '@tabler/icons-react';
import { useRouter } from 'next/navigation';
import { useUser } from '@/context/UserContext';
import { trackEvent } from '@/lib/telemetry';

// Favorieten-hartje voor set-kaarten en de setpagina. Consumeert zelf de
// UserContext zodat gememoizede kaarten (SetCard) geen props nodig hebben.
// Zonder account stuurt een klik naar de loginpagina.
export function FavoriteHeart({ setId, size = 'md', style }) {
  const router = useRouter();
  const { account, favoriteIds, toggleFavorite } = useUser();
  const isFavorite = favoriteIds.has(String(setId));

  const handleClick = async (e) => {
    // Kaarten zitten in een <Link>; de klik mag niet navigeren
    e.preventDefault();
    e.stopPropagation();
    if (!account) {
      trackEvent('Favorite Login Required');
      router.push('/account/login');
      return;
    }
    await toggleFavorite(String(setId));
  };

  return (
    <Tooltip label={account ? (isFavorite ? 'Remove from favorites' : 'Add to favorites') : 'Log in to save favorites'} withArrow>
      <ActionIcon
        variant={isFavorite ? 'filled' : 'default'}
        color={isFavorite ? 'red' : 'gray'}
        radius="xl"
        size={size}
        onClick={handleClick}
        aria-label={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
        style={style}
      >
        {isFavorite ? <IconHeartFilled size={16} /> : <IconHeart size={16} />}
      </ActionIcon>
    </Tooltip>
  );
}
